<template>
  <div class="">
    <div>
      <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
        <defs>
          <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"/>
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="48" y="7" class="wave-svg-color"/>
          <use xlink:href="#gentle-wave" x="48" y="10" class="wave-svg-color"/>
          <use xlink:href="#gentle-wave" x="48" y="10" class="wave-svg-color"/>
        </g>
      </svg>
    </div>
    <div class="f300-background py-2">
      <b-container class="">
        <b-row class="mt-3">
          <b-col lg="3">
            <div class="col-lg-12 text-center f300-site-info">

              <m-a :href="{name:'Home'}" class="my-2">
                <img class="col-lg-12 f300-logo" :src="findAttributeOnSiteInfo('icon')[0]"
                     :alt="findAttributeOnSiteInfo('site_name')[0]">
              </m-a>

              <p class="my-2 text-center"> {{ findAttributeOnSiteInfo('site_name')[0] }}</p>

              <p class="my-2 text-center" v-if="findAttributeOnSiteInfo('slogan')[0]">
                {{ findAttributeOnSiteInfo('slogan')[0] }}
              </p>

              <div class="col-12 d-inline  mb-4" v-if="findAttributeOnSiteInfo('symbol')"
                   v-for="symbol in findAttributeOnSiteInfo('symbol')" v-html="symbol"></div>

            </div>
          </b-col>
          <b-col lg="3" md="12">
            <ul>

              <li class="step text-center my-2 list-group"
                  v-if="findAttributeOnSiteInfo('cell_phone').length || findAttributeOnSiteInfo('tel_phone').length">
              <span>
                <m-ic2 icon="telephone-plus" class="footer-icon-1 text-white"/>
              </span>
                <div
                    class="text-center content"
                    v-for="(cell_phone, index) in findAttributeOnSiteInfo('cell_phone')"
                    :key="index+10"
                >
                  <a :href="`tel:${cell_phone}`" class="mb-1 text-white text-decoration-none">{{ cell_phone }}</a>
                </div>
                <div
                    class=" content"
                    v-for="(tel_phone, index) in findAttributeOnSiteInfo('tel_phone')"
                    :key="index+110"
                >
                  <a :href="`tel:${tel_phone}`" class="mb-1 text-white text-decoration-none">{{ tel_phone }}</a>
                </div>
              </li>

              <li class="step text-center my-2 list-group" v-if="findAttributeOnSiteInfo('address').length">
              <span>
                <m-ic2 icon="pin-map" class="footer-icon-1 text-white"/>
              </span>
                <div
                    class=" content"
                    v-for="(address, index) in findAttributeOnSiteInfo('address')"
                    :key="index+10"
                >
                  <p class="mb-1 text-white text-decoration-none">{{ address }}</p>
                </div>
              </li>

              <li class="step text-center my-2 list-group"
                  v-if="findAttributeOnSiteInfo('email').length || findAttributeOnSiteInfo('fax')">
              <span>
                <m-ic2 icon="envelope-open" class="footer-icon-1 text-white"/>
              </span>
                <div
                    class=" content"
                    v-for="(fax, index) in findAttributeOnSiteInfo('fax')"
                    :key="index+10"
                >
                  <p class="mb-1 text-center text-white text-decoration-none">{{ fax }}</p>
                </div>

                <a v-for="(email, index) in findAttributeOnSiteInfo('email')" :key="index+20"
                   :href="`mailto:${email}`" class="text-decoration-none text-center text-white">
                  <p>
                    {{ email }}
                  </p>
                </a>

              </li>


            </ul>
          </b-col>
          <b-col lg="3" class="f300-socials">
            <div class="col-lg-12 mx-auto text-center col-md-12 col-sm-12" id="st-1">


              <a target="_blank" v-for="whatsapp in findAttributeOnSiteInfo('social_media_whatsapp')"
                 :href="`https://wa.me/${whatsapp}`">

                <div class="st-btn" data-network="whatsapp" v-if="findAttributeOnSiteInfo('social_media_whatsapp')">
                  <svg class="" xmlns="http://www.w3.org/2000/svg" color="black" width="16" height="16"
                       fill="currentColor"
                       viewBox="0 0 16 16">
                    <path
                        d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
                  </svg>
                </div>
              </a>

              <a target="_blank" v-for="twitter in findAttributeOnSiteInfo('social_media_twitter')" :href="twitter">

                <div class="st-btn" data-network="twitter">
                  <b-icon icon="twitter" class="h3 mt-2" :href="twitter"></b-icon>
                </div>
              </a>

              <a target="_blank" v-for="telegram in findAttributeOnSiteInfo('social_media_telegram')" :href="telegram">

                <div class="st-btn" data-network="telegram" v-if="telegram">
                  <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
                    <path
                        d="M 20.572266 3.0117188 C 20.239891 2.9764687 19.878625 3.028375 19.515625 3.171875 C 19.065625 3.348875 12.014406 6.3150313 5.4414062 9.0820312 L 3.2695312 9.9960938 C 2.4285313 10.337094 2.0039062 10.891672 2.0039062 11.638672 C 2.0039062 12.161672 2.22525 12.871063 3.28125 13.289062 L 6.9472656 14.757812 C 7.2642656 15.708813 8.0005469 17.916906 8.1855469 18.503906 C 8.2955469 18.851906 8.5733906 19.728594 9.2753906 19.933594 C 9.4193906 19.982594 9.5696563 20.007813 9.7226562 20.007812 C 10.165656 20.007812 10.484625 19.801641 10.640625 19.681641 L 12.970703 17.710938 L 15.800781 20.328125 C 15.909781 20.439125 16.486719 21 17.261719 21 C 18.228719 21 18.962234 20.195016 19.115234 19.416016 C 19.198234 18.989016 21.927734 5.2870625 21.927734 5.2890625 C 22.172734 4.1900625 21.732219 3.6199531 21.449219 3.3769531 C 21.206719 3.1694531 20.904641 3.0469688 20.572266 3.0117188 z M 19.910156 5.171875 C 19.533156 7.061875 17.478016 17.378234 17.166016 18.865234 L 13.029297 15.039062 L 10.222656 17.416016 L 11 14.375 C 11 14.375 16.362547 8.9468594 16.685547 8.6308594 C 16.945547 8.3778594 17 8.2891719 17 8.2011719 C 17 8.0841719 16.939781 8 16.800781 8 C 16.675781 8 16.506016 8.1197812 16.416016 8.1757812 C 15.272669 8.8885973 10.404094 11.662239 8.0078125 13.025391 L 4.53125 11.636719 L 6.21875 10.927734 C 10.51775 9.1177344 18.174156 5.893875 19.910156 5.171875 z"/>
                  </svg>
                </div>
              </a>

              <a target="_blank" v-for="instagram in findAttributeOnSiteInfo('social_media_instagram')"
                 :href="instagram">

                <div class="st-btn" data-network="instagram">
                  <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
                    <path
                        d="M 8 3 C 5.243 3 3 5.243 3 8 L 3 16 C 3 18.757 5.243 21 8 21 L 16 21 C 18.757 21 21 18.757 21 16 L 21 8 C 21 5.243 18.757 3 16 3 L 8 3 z M 8 5 L 16 5 C 17.654 5 19 6.346 19 8 L 19 16 C 19 17.654 17.654 19 16 19 L 8 19 C 6.346 19 5 17.654 5 16 L 5 8 C 5 6.346 6.346 5 8 5 z M 17 6 A 1 1 0 0 0 16 7 A 1 1 0 0 0 17 8 A 1 1 0 0 0 18 7 A 1 1 0 0 0 17 6 z M 12 7 C 9.243 7 7 9.243 7 12 C 7 14.757 9.243 17 12 17 C 14.757 17 17 14.757 17 12 C 17 9.243 14.757 7 12 7 z M 12 9 C 13.654 9 15 10.346 15 12 C 15 13.654 13.654 15 12 15 C 10.346 15 9 13.654 9 12 C 9 10.346 10.346 9 12 9 z"/>
                  </svg>
                </div>
              </a>

              <a target="_blank" v-for="linkedin in findAttributeOnSiteInfo('social_media_linkedin')" :href="linkedin">
                <div class="st-btn" data-network="linkedin">
                  <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30px" height="30px">
                    <path
                        d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M10.496,8.403 c0.842,0,1.403,0.561,1.403,1.309c0,0.748-0.561,1.309-1.496,1.309C9.561,11.022,9,10.46,9,9.712C9,8.964,9.561,8.403,10.496,8.403z M12,20H9v-8h3V20z M22,20h-2.824v-4.372c0-1.209-0.753-1.488-1.035-1.488s-1.224,0.186-1.224,1.488c0,0.186,0,4.372,0,4.372H14v-8 h2.918v1.116C17.294,12.465,18.047,12,19.459,12C20.871,12,22,13.116,22,15.628V20z"/>
                  </svg>
                </div>
              </a>

              <a target="_blank" v-for="youtube in findAttributeOnSiteInfo('social_media_youtube')" :href="youtube">
                <div class="st-btn" data-network="youtube">
                  <b-icon icon="youtube" class="h3 mt-2 text-danger" href="#"></b-icon>
                </div>
              </a>

              <a target="_blank" v-for="pinterest in findAttributeOnSiteInfo('social_media_pinterest')"
                 :href="pinterest">
                <div class="st-btn" data-network="pinterest">
                  <svg class="mt-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27" width="27px"
                       height="27px">
                    <path
                        d="M 12 2 C 6.477 2 2 6.477 2 12 C 2 17.523 6.477 22 12 22 C 17.523 22 22 17.523 22 12 C 22 6.477 17.523 2 12 2 z M 12 4 C 16.418 4 20 7.582 20 12 C 20 16.418 16.418 20 12 20 C 11.264382 20 10.555494 19.892969 9.8789062 19.707031 C 10.09172 19.278284 10.282622 18.826454 10.386719 18.425781 C 10.501719 17.985781 10.972656 16.191406 10.972656 16.191406 C 11.278656 16.775406 12.173 17.271484 13.125 17.271484 C 15.958 17.271484 18 14.665734 18 11.427734 C 18 8.3227344 15.467031 6 12.207031 6 C 8.1520313 6 6 8.7215469 6 11.685547 C 6 13.063547 6.73325 14.779172 7.90625 15.326172 C 8.08425 15.409172 8.1797031 15.373172 8.2207031 15.201172 C 8.2527031 15.070172 8.4114219 14.431766 8.4824219 14.134766 C 8.5054219 14.040766 8.4949687 13.958234 8.4179688 13.865234 C 8.0299688 13.394234 7.71875 12.529656 7.71875 11.722656 C 7.71875 9.6496562 9.2879375 7.6445312 11.960938 7.6445312 C 14.268937 7.6445313 15.884766 9.2177969 15.884766 11.466797 C 15.884766 14.007797 14.601641 15.767578 12.931641 15.767578 C 12.009641 15.767578 11.317063 15.006312 11.539062 14.070312 C 11.804063 12.953313 12.318359 11.747406 12.318359 10.941406 C 12.318359 10.220406 11.932859 9.6191406 11.130859 9.6191406 C 10.187859 9.6191406 9.4296875 10.593391 9.4296875 11.900391 C 9.4296875 12.732391 9.7109375 13.294922 9.7109375 13.294922 C 9.7109375 13.294922 8.780375 17.231844 8.609375 17.964844 C 8.5246263 18.326587 8.4963381 18.755144 8.4941406 19.183594 C 5.8357722 17.883113 4 15.15864 4 12 C 4 7.582 7.582 4 12 4 z"/>
                  </svg>
                </div>
              </a>

              <a target="_blank" class="p-0" v-for="aparat in findAttributeOnSiteInfo('social_media_aparat')"
                 :href="aparat">
                <div class="st-btn" data-network="aparat">

                  <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="27px" height="27px">
                    <path
                        d="M 15.173828 2.609375 C 11.917119 2.5264688 8.94875 4.7335781 8.1875 8.0332031 L 7.078125 12.837891 C 10.172125 7.7938906 15.497719 4.4664844 21.386719 3.8964844 L 16.582031 2.7871094 C 16.110656 2.6782344 15.639072 2.6212187 15.173828 2.609375 z M 23.615234 7 C 16.369702 7.1611924 9.7609531 11.980828 7.6582031 19.314453 C 5.0702031 28.340453 10.289453 37.753797 19.314453 40.341797 C 28.339453 42.929797 37.753797 37.711547 40.341797 28.685547 C 42.929797 19.659547 37.711547 10.246203 28.685547 7.6582031 C 26.993172 7.1729531 25.28728 6.9628018 23.615234 7 z M 35.162109 7.078125 C 40.206109 10.172125 43.533516 15.497719 44.103516 21.386719 L 45.212891 16.582031 C 46.083891 12.811031 43.737797 9.0575 39.966797 8.1875 L 35.162109 7.078125 z M 20.191406 12.589844 C 20.456244 12.610334 20.723031 12.658375 20.988281 12.734375 C 23.111281 13.342375 24.338469 15.556687 23.730469 17.679688 C 23.122469 19.802687 20.906203 21.029875 18.783203 20.421875 C 16.660203 19.813875 15.433969 17.599562 16.042969 15.476562 C 16.575844 13.618937 18.337541 12.446412 20.191406 12.589844 z M 31.726562 15.898438 C 31.991494 15.918996 32.258063 15.966844 32.523438 16.042969 C 34.646437 16.650969 35.874625 18.865281 35.265625 20.988281 C 34.657625 23.110281 32.441359 24.338469 30.318359 23.730469 C 28.195359 23.122469 26.968172 20.908156 27.576172 18.785156 C 28.108172 16.927531 29.872041 15.754527 31.726562 15.898438 z M 24.035156 22.001953 C 25.139156 22.020953 26.017047 22.930156 25.998047 24.035156 C 25.979047 25.139156 25.069844 26.017047 23.964844 25.998047 C 22.860844 25.979047 21.982953 25.069844 22.001953 23.964844 C 22.020953 22.860844 22.930156 21.982953 24.035156 22.001953 z M 16.884766 24.126953 C 17.149697 24.147443 17.416266 24.193531 17.681641 24.269531 C 19.804641 24.877531 21.032828 27.093797 20.423828 29.216797 C 19.814828 31.339797 17.598563 32.566031 15.476562 31.957031 C 13.353562 31.349031 12.125375 29.134719 12.734375 27.011719 C 13.266375 25.154094 15.030244 23.983521 16.884766 24.126953 z M 3.8964844 26.615234 L 2.7871094 31.419922 C 1.9171094 35.190922 4.2622031 38.943453 8.0332031 39.814453 L 12.837891 40.923828 C 7.7948906 37.829828 4.4664844 32.504234 3.8964844 26.615234 z M 28.417969 27.433594 C 28.6829 27.454084 28.951422 27.502125 29.216797 27.578125 C 31.339797 28.186125 32.566031 30.400437 31.957031 32.523438 C 31.348031 34.646437 29.134719 35.873625 27.011719 35.265625 C 24.888719 34.657625 23.661531 32.443313 24.269531 30.320312 C 24.801531 28.462687 26.563447 27.290162 28.417969 27.433594 z M 40.923828 35.162109 C 37.829828 40.205109 32.504234 43.533516 26.615234 44.103516 L 31.419922 45.212891 C 35.190922 46.082891 38.943453 43.737797 39.814453 39.966797 L 40.923828 35.162109 z"/>
                  </svg>

                </div>
              </a>


            </div>

          </b-col>
          <b-col lg="3" class="f300-menu">
            <MainFooterMenu class="f300-menu"/>
          </b-col>
        </b-row>

        <div class="row f300-bottom-section text-center pt-5 ">
          <b-col md="6">
            <h6 :class="{'d-none':!signature}"> ساخته شده توسط <a class=" text-white text-decoration-none"
                                                                  href="https://mixitweb.com/">Mixitweb.com</a></h6>
            <slot></slot>
          </b-col>
          <b-col md="6">
            <h6 class="color-of-address">{{ findAttributeOnSiteInfo("copy_right")[0] }}</h6>
          </b-col>
        </div>


      </b-container>
    </div>
  </div>
</template>

<script>
import MainFooterMenu from './MainFooterMenu'

export default {
  name: "F300",
  components: {MainFooterMenu},
  props: {
    signature: {
      default: false,
    }
  },
}
</script>

<style>
.f300-menu * {
  color: white !important;
  fill: white !important;
}
</style>

<style scoped>
.waves {
  position: relative;
  width: 100%;
  height: 15vh;
  margin-bottom: -7px; /*Fix for safari gap*/
  min-height: 80px;
  max-height: 120px;
}

/* Animation */

.parallax > use {
  animation: move-forever 25s cubic-bezier(.55, .5, .45, .5) infinite;
}

.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 7s;
}

.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 10s;
}

.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 13s;
}

.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 20s;
}

@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}

/*Shrinking for mobile*/
@media (max-width: 768px) {
  .waves {
    height: 40px;
    min-height: 40px;
  }
}

.wave-svg-color {
  fill: var(--light-success);
}

.f300-background {
  background: var(--light-teal);
}

.f300-bottom-section *, .f300-background {
  font-size: 0.875rem !important;
}


.f300-logo {
  width: 90px;
}


#st-1 .st-btn {
  box-sizing: border-box;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  margin-right: 8px;
  padding: 0 10px;
  position: relative;
  text-align: center;
  top: 0;
  vertical-align: top;
  white-space: nowrap;
}

.f300-socials, .f300-menu {
  display: table;
}

.f300-socials > div, .f300-menu > div {
  display: table-cell;
  vertical-align: middle;
}

.f300-socials *,.f300-site-info,.f300-bottom-section * {
  fill: white;
  color: white;
}

</style>